<!DOCTYPE html>
<html>
  <head>
    <title>Coverpath</title>
    <link rel="stylesheet" href="/dist/coverpath-client/coverpath-client.css" />
    <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0" />
    <meta name="robots" content="noindex, nofollow, noarchive, nosnippet, notranslate" />
  </head>

  <body>
    <div class="sign-complete">
      <div class="sign-complete__content">
        <h1 class="sign-complete__title">Thank you for signing.</h1>
        <p class="sign-complete__text">We have submitted your life insurance application.</p>
      </div>
    </div>
  </body>
</html>
